"use strict";
import { jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { BreadcrumbRoot as CommonBreadcrumbRoot } from "capitalrx-components-2.0/lib/shell";
import { useModulePathResolver } from "../hooks";
export { Breadcrumb, Breadcrumbs, BreadcrumbItem, BreadcrumbItems, useCurrentBreadcrumb } from "capitalrx-components-2.0/lib/shell";
const useModuleBreadcrumbPathResolver = () => {
  const resolve = useModulePathResolver();
  return useCallback((path) => resolve(path), [resolve]);
};
export const BreadcrumbRoot = (props) => {
  const { children } = props;
  const handleActiveTitleChange = useCallback((activeTitle) => {
    let title = site ? site.companyName : "Capital Rx";
    if (activeTitle) title += ` - ${activeTitle}`;
    if (title !== void 0) document.title = title;
  }, []);
  return /* @__PURE__ */ jsx(CommonBreadcrumbRoot, { usePathResolver: useModuleBreadcrumbPathResolver, onActiveTitleChange: handleActiveTitleChange, children });
};
